import { Box, Checkbox, Table, TableBody, TableCell, TableHead } from "@material-ui/core";
import { useTypeSelectors } from "hooks/useTypeSelectors";
import { FC, useEffect, useState } from "react";
import { FLEET_TABLE_HEADERS_COLUMN } from "../tableData";
import { useDispatch } from "react-redux";
import { EnchancedSortLabel } from "components/tables/tableSortLabel";
import { FleetStatusRow } from "./FleetStatusRow";
import { fleetUpdateSettings, selectAllFleetIdsList } from "actions/daAndFleetActions";
import { useStyles } from "../styles";
import useResize from "hooks/useResize";
import { DISPATCHER, MANAGER } from "constants/constants";

interface PropsType {
  tableNumber: number
}

const FleetStatusTable: FC<PropsType> = ({ tableNumber }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { width } = useResize();
  const { userData } = useTypeSelectors((state) => state.auth);
  const {
    fleetData: { fleetList, fleetListFilters, idListForUpdate },
  } = useTypeSelectors((state) => state.daAndFleets);
  const [sortId, setSortId] = useState<string>(fleetListFilters?.ordering || "number");

  useEffect(() => {
    setSortId(fleetListFilters?.ordering)
  }, [fleetListFilters?.ordering])

  const handleSortChange = (sortId: string | undefined, cellId: string) => {
    if (sortId?.replace("-", "") === cellId) {
      const sortString = `${sortId?.includes("-") ? "" : "-"}${cellId}`;
      setSortId(sortString);
      dispatch(fleetUpdateSettings({ ordering: sortString }));
    } else {
      setSortId(cellId);
      dispatch(fleetUpdateSettings({ ordering: cellId }));
    }
  };

  return (
    <Table stickyHeader>
      <TableHead>
        {tableNumber === 1 && (
          <TableCell className={classes.tableHeadCell}>
            <Box className={classes.tableCellContent}>
              <Checkbox
                onChange={() => dispatch(selectAllFleetIdsList())}
                checked={fleetList.length === idListForUpdate?.length}
                className={classes.selectCheckbox}
                disabled={[DISPATCHER, MANAGER].includes(userData.role)}
              />
            </Box>
          </TableCell>
        )}
        {FLEET_TABLE_HEADERS_COLUMN?.filter((col) =>
          width > 840
            ? col.table === tableNumber
            : tableNumber === 1
              ? ["checkbox"].includes(col.id)
              : !["checkbox"].includes(col.id) || ["number"].includes(col.id),
        )
          ?.filter((col: any) => col.id !== "checkbox")
          ?.filter((col: any) =>
            fleetListFilters?.activeColumns?.length
              ? width > 840
                ? fleetListFilters?.activeColumns?.includes(col.id) || ["number"].includes(col.id)
                : fleetListFilters?.activeColumns?.includes(col.id)
              : true,
          )
          ?.map((col: any) => (
            <TableCell key={col.id} className={`${classes.tableHeadCell} ${classes.fixedHeight}`}>
              <Box className={classes.tableCellContent}>
                <EnchancedSortLabel
                  columnId={col.id}
                  columnLabel={col.label}
                  hasSortLabel={col?.hasSort}
                  handleChange={handleSortChange}
                  ordering={sortId}
                />
              </Box>
            </TableCell>
          ))}
      </TableHead>
      <TableBody>
        {fleetList.map((row) => (
          <FleetStatusRow key={row.id} row={row} tableNumber={tableNumber} />
        ))}
      </TableBody>
    </Table>
  );
};

export default FleetStatusTable;
